import React from 'react';
import './SunPanelSymbol.css';

class SunPanelSymbol extends React.Component<{}, {}> {
    render() {
        return (
            <symbol id="sunpanel" data-name="sunpanel" viewBox="0 0 114.2 139.1">
               <img />
            </symbol>
        );
    }
}

export default SunPanelSymbol;